
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.615 7.651L2.49.16a1.25 1.25 0 00-1.792 1.5L3.12 8.73v.015L.698 15.828a1.25 1.25 0 001.796 1.503l13.118-7.504a1.25 1.25 0 00.004-2.179l-.001.003zm-13.74 8.594v-.007L4.23 9.37h4.52a.625.625 0 000-1.25H4.236L1.88 1.254l-.005-.009L15 8.732 1.875 16.245z","fill":"#1C1C1C"}})])
          )
        }
      }
    